import { render, staticRenderFns } from "./FashionHeader.vue?vue&type=template&id=a2b662b2&scoped=true&"
import script from "./FashionHeader.vue?vue&type=script&lang=ts&"
export * from "./FashionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FashionHeader.vue?vue&type=style&index=0&id=a2b662b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b662b2",
  null
  
)

export default component.exports